import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ConversationAssistantNavBarButton: LoadableType<{
	shouldRenderControllers?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConversationAssistantNavBarButton" */ '../src/navBarButton.tsx'
			)
		).ConversationAssistantNavBarButton,
});
